import { module } from 'angular';

import { BasketEffect, default as basketEffectName } from './basket.effect';
import { BasketStore, default as basketStoreName } from './basket.store';
import { default as mailBasketName, MailBasket } from './mail/mail-basket.component.ajs';
import { default as mailBasketServiceName, MailBasketService } from './mail/mail-basket.service';
import { default as visioBasketName, VisioBasket } from './visio/visio-basket.component.ajs';
import { default as visioBasketServiceName, VisioBasketService } from './visio/visio-basket.service';

export default module('contact.agent.core.basket', [])
  // instanciate services module
  .run([mailBasketServiceName, visioBasketServiceName, basketStoreName, basketEffectName, () => {}])
  // service
  .service(mailBasketServiceName, MailBasketService)
  .service(visioBasketServiceName, VisioBasketService)
  // store
  .service(basketStoreName, BasketStore)
  // effect
  .service(basketEffectName, BasketEffect)
  // component
  .component(mailBasketName, new MailBasket())
  .component(visioBasketName, new VisioBasket()).name;
